import { GET_DEALERS_REQUEST, GET_DEALERS_SUCCESS, GET_DEALERS_FAILURE } from '../actions/dealers';

const initialState = {
    fetching: false,
    dealers: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_DEALERS_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_DEALERS_SUCCESS: {
            return {
                ...state,
                fetching: false,
                dealers: action.payload.dealers || []
            };
        }
        case GET_DEALERS_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        default: return state;
    }
};
